function BulkCostCtrl($state, $auth, $stateParams, BulkCostService, AppSettings, CommonService, $rootScope, UserService, toaster) {
  'ngInject';

  $rootScope.$on("UpdateBulkCostJournalFromNotification", function(event, bulk_cost_journal){
    vm.updateBulkCostJournalFromNotification(bulk_cost_journal);
  });
  const vm = this;
  vm.bulkCostForm = {};
  vm.bulkCostJournals = [];
  vm.loading= false;
  vm.pageNumber = !$stateParams.pageNumber ? 1 : $stateParams.pageNumber;
  vm.size = !$stateParams.size ? 50 : $stateParams.size;
  vm.journalId = !$stateParams.journalId ? '' : $stateParams.journalId;
  vm.accountId = !$stateParams.accountId ? '' : $stateParams.accountId;
  vm.bulkCostForm.todate = !$stateParams.todate? '' : $stateParams.todate;
  vm.bulkCostForm.fromdate = !$stateParams.fromdate? '' : $stateParams.fromdate;
  vm.sortBy = !$stateParams.sortBy? '' : $stateParams.sortBy;
  vm.sortFlag = false;
  vm.user = $auth.user;
  vm.dataloading=false;
  vm.dateRegex = AppSettings.dateRegex;
  vm.isBulkPendingJobs = false;

  vm.init  = function () {
    vm.url = `/organizations/${$stateParams.orgId}/bulk_cost_journals.json?page=${vm.pageNumber}&size=${vm.size}&by_journal_id=${vm.journalId}&by_account=${vm.accountId}&by_from=${vm.bulkCostForm.fromdate}&by_to=${vm.bulkCostForm.todate}&sort=${vm.sortBy}`;
    if($stateParams.orgId) {
      vm.dataloading=true;
         BulkCostService.getbulkJournals($stateParams.orgId, vm.url, vm.pageNumber, vm.size, function (response) {
           vm.dataloading = false;
           if(response.status = 200) {
             vm.bulkCostResponse = response.data;
             vm.currentPage = !vm.bulkCostResponse.pagination ? 1 : vm.bulkCostResponse.pagination.current_page;
             vm.totalPages = !vm.bulkCostResponse.pagination ? 1 : vm.bulkCostResponse.pagination.total_pages;
             vm.bulkCostJournals = response.data.bulk_cost_journals;
           }
    });
    vm.getAccounts();
    vm.pending();
    }
  };

  vm.pending = function(){
    UserService.showBulkPendingJob( $stateParams.orgId, function (response){
        vm.isBulkPendingJobs = response && response.data && response.data.count > 0;
      });
  }

  vm.viewDetail = function(bulkCostid) {
      $state.go('user.organization.dashboard.bulk-detail', {orgId: $stateParams.orgId, bulkCostid : bulkCostid}, {inherit: false});
  };

  vm.retryBulkCost = function (accountCode, journalDate) {
    if(accountCode){
      BulkCostService.retryBulkCostProcess($stateParams.orgId, accountCode, journalDate, function (response) {
        if(response.status == 200){
          toaster.pop('info', 'Successfully started bulk cost journal job. It might take a while.');
        } else {
          toaster.pop('Couldnt start job. Try again later');
        }
      });
    }
  };

  vm.getJournal = function() {
    if ($stateParams.bulkCostid){
     BulkCostService.getJournal($stateParams.orgId, $stateParams.bulkCostid, function(response){
          vm.journal = response.data;
      });
    }
    else {
      $state.go('user.organization.dashboard.bulk', {inherit: false});
    }
  };

  vm.getAccounts = function(){
   CommonService.getAccounts($stateParams.orgId, function (response) {
     if(response.status == 200){
        vm.accounts = response.data;
        if($stateParams.accountId) {
         vm.account = vm.accounts.find(x => x.id == $stateParams.accountId);

        }}
     });
  }
  vm.search = function (account, jrId, fromdate, todate) {
    $state.go('user.organization.dashboard.bulk', {pageNumber: vm.pageNumber, size: vm.size, accountId: !account? '' : account.id, journalId: jrId, fromdate: fromdate, todate: todate})
  };
  vm.updateBulkCostJournalFromNotification = function(bulk_cost_journal) {
    if(Array.isArray(bulk_cost_journal))
    {
      vm.init();
    }
  };

  vm.sortFlag = function(param) {
    // console.log(param)
    var currentSort = $stateParams.sortBy;
    if(currentSort && currentSort.includes(param))
    {
      if(!currentSort.includes('-'))
      {
        return false;
      }
    }
    return true;
  };

  vm.sort = function(param) {

    var currentSort = $stateParams.sortBy;
    if(currentSort && currentSort.includes(param))
    {
      if(!currentSort.includes('-'))
      {
        param = '-' + param;
      }
    }
    $state.go('user.organization.dashboard.bulk', {sortBy: param});
  };

  vm.paginate = function (param) {
    vm.url = vm.bulkCostResponse.links[param];
    if(vm.url) {
      var arr = vm.url.split('?');
      vm.pageNumber = CommonService.getParameterByName('page', vm.url);
      vm.url = arr[0] + '.json?page=' + vm.pageNumber + '&size=' + vm.size;
      $state.go('user.organization.dashboard.bulk', {pageNumber: vm.pageNumber, size: vm.size});
    }
  };

  vm.rowChange = function (param, pageSize) {
    vm.url = vm.bulkCostResponse.links[param];
    var arr = vm.url.split('?');
    vm.pageNumber = 1;
    vm.size = pageSize;
    vm.url = arr[0]+ '.json?page='+ vm.pageNumber + '&size='+ vm.size;
    $state.go('user.organization.dashboard.bulk', {pageNumber: vm.pageNumber, size: vm.size})
  };

  vm.onPickadayTo = function (pikaday) {
    vm.bulkCostForm.todate = pikaday.toString();
    vm.fromDatePicker.setMaxDate(new Date(vm.bulkCostForm.todate));
  };

  vm.onPickadayFrom = function(pikaday) {
    vm.bulkCostForm.fromdate = pikaday.toString();
    vm.toDatePicker.setMinDate(new Date(vm.bulkCostForm.fromdate));
  };

  vm.bulkCostJournal = function () {
    vm.loading = true;
    BulkCostService.calculateBulkCostJournal($stateParams.orgId, function(response) {
      vm.loading = false;
      if(response.status == 200){
        toaster.pop('info', 'Successfully started bulk cost journal job. It might take a while.');
      }
    });
  };

  vm.getStatusClass = function (status) {
    let label = '';
    switch (status) {
      case 'initial':
        label = 'label-primary';
        break;
      case 'running':
        label = 'label-warning';
        break;
      case 'success':
        label = 'label-success';
        break;
      case 'error':
        label = 'label-danger';
        break;
      case 'manual':
        label = 'label-success';
        break;
      default:
    }
    return label;
  };
}

export default{
  name: 'BulkCostCtrl',
  fn: BulkCostCtrl
}
